import { useQuery } from 'react-query';
import { filterUsers } from '../utils/Network';

async function fetchUsersList(filterQuery, page) {
    const data = await filterUsers(filterQuery, page);
    console.log(data);
    if (data && data.results) {
        return data;
    }
    return { count: 0, results: [] };
}

/**
 * @param {number} page — 1-based page index for the API
 * @param {string} filterQuery — suffix query string (e.g. "&first_name=…")
 */
export function useCmsUsersList(page, filterQuery) {
    return useQuery(
        ['cms', 'users', 'list', page, filterQuery],
        () => fetchUsersList(filterQuery, page),
        {
            keepPreviousData: true,
        }
    );
}
